export default `
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 10;
`;



// WEBPACK FOOTER //
// ./app/components/Chart/OverlayStyles.js